module.exports = __webpack_public_path__ + "static/fede-2-6a8815974fbd6181b0412c73ea5104e5.png";